import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { FC } from "react";
import ButtonComponent, {
  ButtonProps,
} from "../../../../../common/components/button/button.component";

type OrderDetailsToolButtonProps = Pick<
  ButtonProps,
  "onClick" | "title" | "isDisabled" | "type" | "isLoading"
> & {
  icon: IconProp;
  isActive?: boolean;
};

const OrderDetailsToolButtonComponent: FC<OrderDetailsToolButtonProps> = ({
  type = "primary",
  ...props
}) => {
  return (
    <ButtonComponent
      onClick={props.onClick}
      title={props.title}
      classNames={{
        root: classNames(
          "order_details_tools_button",
          props.isActive && "active",
        ),
      }}
      type={type}
      isDisabled={props.isDisabled}
      isLoading={props.isLoading}
    >
      <FontAwesomeIcon
        icon={props.icon}
        className="order_details_tools_button__icon"
      />
    </ButtonComponent>
  );
};

export default OrderDetailsToolButtonComponent;
